/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Fonts_Preview_SentenceInputs */

const en_options_fonts_preview_sentence = /** @type {(inputs: Options_Fonts_Preview_SentenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The quick brown fox jumps over the lazy dog`)
};

const fr_options_fonts_preview_sentence = /** @type {(inputs: Options_Fonts_Preview_SentenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portez ce vieux whisky au juge blond qui fume`)
};

const de_options_fonts_preview_sentence = /** @type {(inputs: Options_Fonts_Preview_SentenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der schnelle braune Fuchs springt über den faulen Hund`)
};

const it_options_fonts_preview_sentence = /** @type {(inputs: Options_Fonts_Preview_SentenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La volpe marrone salta veloce sopra il cane pigro`)
};

const ru_options_fonts_preview_sentence = /** @type {(inputs: Options_Fonts_Preview_SentenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Быстрая бурая лиса перепрыгивает через ленивую собаку.`)
};

const es_options_fonts_preview_sentence = /** @type {(inputs: Options_Fonts_Preview_SentenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El rápido zorro marrón salta sobre el perro perezoso.`)
};

const zh_cn2_options_fonts_preview_sentence = /** @type {(inputs: Options_Fonts_Preview_SentenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`敏捷的棕色狐狸跳过了懒惰的狗`)
};

const ja_options_fonts_preview_sentence = /** @type {(inputs: Options_Fonts_Preview_SentenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`素早い茶色のキツネが怠け者の犬を飛び越える`)
};

const hi_options_fonts_preview_sentence = /** @type {(inputs: Options_Fonts_Preview_SentenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तेज, भूरी लोमडी आलसी कुत्ते के उपर कूद गई`)
};

const pt_pt2_options_fonts_preview_sentence = /** @type {(inputs: Options_Fonts_Preview_SentenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A raposa marrom veloz salta sobre o cachorro preguiçoso.`)
};

/**
* | output |
* | --- |
* | "The quick brown fox jumps over the lazy dog" |
*
* @param {Options_Fonts_Preview_SentenceInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_fonts_preview_sentence = /** @type {((inputs?: Options_Fonts_Preview_SentenceInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Fonts_Preview_SentenceInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_fonts_preview_sentence(inputs)
	if (locale === "de") return de_options_fonts_preview_sentence(inputs)
	if (locale === "it") return it_options_fonts_preview_sentence(inputs)
	if (locale === "ru") return ru_options_fonts_preview_sentence(inputs)
	if (locale === "es") return es_options_fonts_preview_sentence(inputs)
	if (locale === "zh-CN") return zh_cn2_options_fonts_preview_sentence(inputs)
	if (locale === "ja") return ja_options_fonts_preview_sentence(inputs)
	if (locale === "hi") return hi_options_fonts_preview_sentence(inputs)
	if (locale === "pt-PT") return pt_pt2_options_fonts_preview_sentence(inputs)
	return en_options_fonts_preview_sentence(inputs)
});